<template>
  <div>
    <a-tabs default-active-key="1">
      <a-tab-pane tab="APROBADORES PAZ Y SALVO" key="1">
        <g-master :name="master.endpoint"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
        >
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Persona')"
                          :formItemConfig="fiOptions"
                          endpoint="personas"
                          :decorator="['id_person', { rules: [{ required: true, message: 'Valor requerido' }]}]">
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            :label="$t('Proceso')"
                            :formItemConfig="fiOptions"
                            :selectedObj.sync="tipoProcesoSeleccionado"
                            :decorator="['type_peacesafe', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                            :params="tipo_proceso">
                </g-dropdown>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        tipoProcesoSeleccionado: {},
        tipo_proceso: {
          h_lookup_type: 'PROCESOS_PAZYSALVO', use_code: true
        },
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'param_peacesafe',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'ID Persona', dataIndex: 'id_person', sorter: true},
              {title: 'Nombre', dataIndex: 'nombre', sorter: true},
              {title: 'Proceso', dataIndex: 'proceso_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'id_person'},
            {name: 'type_peacesafe'}
          ]
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/PazYSalvo/ParamPeaceSafe.vue